exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading{\n\t\tdisplay: flex;\n\t    justify-content: center;\n\t    align-items: center;\n}\n.shw-rside{\n        width: 500px;\n}\n", ""]);

// exports
